import { useQuery } from '@tanstack/react-query';
import { useNotification } from '../useNotification';
import { useFetchApi } from '../useFetchApi';
import { Webhook } from '../../shared/types';

const WEBHOOKS_STALE_TIME_IN_MS = 5 * 60 * 1000;

export const useListWebhooks = () => {
  const fetch = useFetchApi();
  const { showErrorWithResponse } = useNotification();

  return useQuery({
    queryKey: ['webhooks'],
    queryFn: () => fetch('webhooks') as Promise<Webhook[]>,
    onError: showErrorWithResponse,
    refetchOnWindowFocus: false,
    staleTime: WEBHOOKS_STALE_TIME_IN_MS,
  });
};
